// extracted by mini-css-extract-plugin
export default {"show-quote-form":"ShowQuote_show-quote-form__bCgm1"};